import React from "react";
import "./ReferenceHowItWorks.css";

// NEW UI: Dedicated recreation of the three distinct animated previews in the supplied #how section.
const steps = [
  ["1", "Upload your documents", "Genie, your personal AI assistant, reads your files, extracts key details, and answers questions about any funding opportunity.", "upload"],
  ["2", "Pick the right grant", "Grant Finder surfaces opportunities that match your mission, so you only chase grants worth winning.", "finder"],
  ["3", "Generate & refine", "The AI drafts a tailored, funder-compliant proposal. Edit with smart suggestions and export to PDF or DOCX.", "draft"],
];

function Preview({ type }) {
  if (type === "upload") return <div className="how-preview upload-preview"><b>UPLOADING GRANT_DOCS.PDF</b><span><i /></span></div>;
  if (type === "finder") return <div className="how-preview finder-preview"><em />{["Community Health Grant", "Food Security Fund", "Youth Arts Initiative"].map((name, index) => <div key={name}>{name}<b>${120 - index * 40}k</b></div>)}</div>;
  return <div className="how-preview draft-preview"><i /><i /><i /></div>;
}

export default function ReferenceHowItWorks() {
  return <section id="how" className="reference-how"><div className="section-heading"><h2>Fast & easy grant writing</h2><p>From blank page to funder-ready proposal in three steps</p></div><div className="reference-step-grid">{steps.map(([number, title, text, type]) => <article className="reference-step" key={number}><b className="step-number">{number}</b><Preview type={type} /><h3>{title}</h3><p>{text}</p></article>)}</div></section>;
}
